export const cartAnnouncement = () => {
    document.addEventListener( 'DOMContentLoaded', () => {
        let newsletterCart = document.getElementById("newsletterCart");
        if(newsletterCart) {
            newsletterCart.addEventListener("click", () =>{
            scrollDown();
            })
        }

        function scrollDown(){
            let elm = document.documentElement;
            //scrollHeight ページの高さ clientHeight ブラウザの高さ
            let bottom = elm.scrollHeight - elm.clientHeight;
            //垂直方向へ移動
            window.scrollTo({
                top: bottom,
                behavior: 'smooth',
            });
        }
    })
}